module.exports = __webpack_public_path__ + "static/media/vinglabs_automate_color_transparent.3145e787.png";